import React, { cloneElement } from "react";

import { AuthProvider } from "./auth";
import { FetchProvider } from "./fetch";
import { ScrollProvider } from "./scroll";
import { ToggleProvider } from "./toggle";
import { CartProvider } from "./cart";

function ContextProvider({ children }) {
  function ProviderComposer({ contexts, children }) {
    return contexts.reduceRight(
      (kids, parent) =>
        cloneElement(parent, {
          children: kids,
        }),
      children
    );
  }

  return (
    <ProviderComposer
      contexts={[
        <FetchProvider />,
        <AuthProvider />,
        <ScrollProvider />,
        <ToggleProvider />,
        <CartProvider />,
      ]}
    >
      {children}
    </ProviderComposer>
  );
}

export { ContextProvider };
